import type { ImportTemplateT } from '../types';

export const ZendeskImportTemplate: ImportTemplateT = {
  status: {
    enable: true,
    solved: [4, 'solved'],
    pending: [1, 'pending'],
    sovledOrPending: [3, 'pending or solved'],
  },
  bound: {
    enable: false,
    all: [1, 'All'],
    inbound: [2, 'Inbound only'],
    outbound: [3, 'Outbound only'],
  },
  tag: {
    enable: true,
    all: [1, 'All'],
    import: [2, 'Import only tickets with these tags'],
    doNotImport: [3, 'Do not import tickets with these tags'],
  },
};
